export const PATHWAY_INCOMPLETE_REQUEST = "PATHWAY_INCOMPLETE_REQUEST";
export const PATHWAY_INCOMPLETE_RECEIVE = "PATHWAY_INCOMPLETE_RECEIVE";
export const PATHWAY_INCOMPLETE_FAILURE = "PATHWAY_INCOMPLETE_FAILURE";
export const RESET_PATHWAY_INCOMPLETE = "RESET_PATHWAY_INCOMPLETE";
